// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__g9lWW"};